interface ViewButtonProps {
    onClick: () => void;
}

export default function ViewButton({ onClick }: ViewButtonProps) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="rounded-lg bg-secondary px-5 py-1.5 text-[13px] font-medium text-white transition-colors hover:bg-secondary-400"
        >
            View
        </button>
    );
}
